import React from 'react'
import Header from '../../Header/Header'
import StrategyAssesmentTwoMain from './StrategyAssesmentTwoMain'

const StrategyAssesmentTwoBody = () => {
  return (
    <div id="strategy_Assesment_Two">
      <Header title="Strategy Assesment Two" domId="strategy_Assesment_Two" />
      <StrategyAssesmentTwoMain />
    </div>
  )
}

export default StrategyAssesmentTwoBody
